export const INVESTOR = {
  SET_INVESTORS: 'SET_INVESTORS',
  SET_INVESTOR: 'SET_INVESTOR'
};

export const CFG = {
  BASE_URL: 'BASE_URL'
}

export const USER = {
  SET_NAME: 'SET_NAME',
  ACCEPT_AGREEMENT: 'ACCEPT_AGREEMENT',
  SET_TOOLTIP: 'SET_TOOLTIP'
};

export const PIN = {
  PIN_TRIGGER: 'SET_PIN_TRIGGER',
  SET_PINS: 'SET_PINS'
}

export const IMPERSONATE = {
  SET_IMPERSONATE_ID: 'SET_IMPERSONATE_ID',
  SET_IMPERSONATE_NAME: 'SET_IMPERSONATE_NAME',
  IMPERSONATE_ON: 'IMPERSONATE_ON',
  IMPERSONATE_OFF: 'IMPERSONATE_OFF',
  CAN_IMPERSONATE: 'CAN_IMPERSONATE'
}

export const MODAL = {
  SWITCH_IMPERSONATE_MODE_MODAL: 'SWITCH_IMPERSONATE_MODE_MODAL',
  SWITCH_CASH_FLOW_MODAL: 'SWITCH_CASH_FLOW_MODAL',
  SWITCH_REDIRECTING_TO_DS_MODAL: 'SWITCH_REDIRECTING_TO_DS_MODAL',
  SWITCH_MULTIPLE_DOWNLOAD_MODAL: 'SWITCH_MULTIPLE_DOWNLOAD_MODAL',
  REACHED_LIMIT_MODAL: 'REACHED_LIMIT_MODAL',
  CLOSE_REACHED_LIMIT_MODAL: 'CLOSE_REACHED_LIMIT_MODAL',
  CLOSE_MULTIPLE_DOWNLOAD_MODAL: 'CLOSE_MULTIPLE_DOWNLOAD_MODAL'
}

export const DOCUSIGN = {
  SWITCH_DOCUSIGN_DROPDOWN: 'SWITCH_DOCUSIGN_DROPDOWN',
  CLOSE_DOCUSIGN_DROPDOWN: 'CLOSE_DOCUSIGN_DROPDOWN'
}

export const BOARD = {
  SET_ACTIVE_BOARD: 'SET_ACTIVE_BOARD'
}

export const POPUP = {
  SET_SERVER_ERROR: 'SET_SERVER_ERROR',
  CLOSE_SERVER_ERROR: 'CLOSE_SERVER_ERROR'
}

export const PDF = {
  SHOW_PDF_DIALOG: "SHOW_PDF_DIALOG",
  HIDE_PDF_DIALOG: "HIDE_PDF_DIALOG"
}

export const CHANGE_SIDEBAR_EXPAND = 'CHANGE_SIDEBAR_EXPAND';